
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import MDButton from 'components/MDButton';
import MDInput from "components/MDInput";
import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import { Oval } from 'react-loader-spinner';
import Select from 'react-select';
import * as service from '../../../../services/service';

function AddEditItem() {
    const [state, setState] = useState({ item: '', itemcode: '' });
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [categoryData, setCategoryData] = useState([]);
    const [categoryId, setCategoryId] = useState();
    const [unitData, setUnitData] = useState([]);
    const [unit, setUnit] = useState('');
    const selectStyles = { menu: styles => ({ ...styles, zIndex: 999 }) };
    const navigate = useNavigate();
    const params = useParams();

    const getCategories = () => {
        fetch(
            service.ITEM_CATEGORY_URL,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    ClientId: JSON.parse(sessionStorage.getItem('userData')).clientId,
                })
            })
            .then(res => res.json())
            .then(result => {
                const data2 = result.map((item) => ({ value: item.itemCategoryId, label: item.itemCategory }));
                setCategoryData(data2);
            })
            .catch(err => {
                if (err) {
                    setErrors(err);
                };
            });
    }
    const getUnit = () => {
        fetch(
            service.UNIT_URL,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    ClientId: JSON.parse(sessionStorage.getItem('userData')).clientId
                })
            })
            .then(res => res.json())
            .then(result => {
                const data2 = result.map((item) => ({ value: item.unitId, label: item.unit }));
                setUnitData(data2);
            });
    };

    const getDetailsById = () => {
        setLoading(true);
        const errs = {};
        if (params.id > 0) {
            fetch(
                service.GET_ITEM_BY_ID,
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        ItemId: params.id,
                    })
                })
                .then(res => res.json())
                .then(result => {
                    if (result.message.messageType === 'Success') {
                        setState({ ...state, item: result.item, itemcode: result.itemCode });

                        const cat = ({ label: result.itemCategory, value: result.itemCategoryId });
                        setCategoryId(cat);

                        const un = ({ label: result.unit, value: result.unitId });
                        setUnit(un);
                    }
                    else {
                        errs[".invalid"] = result.message.message;
                        setErrors(errs);
                    }

                });
        }
        setLoading(false);
    };

    useEffect(() => {
        getCategories();
        getUnit();
        if (params.id > 0) {
            getDetailsById();
        }
    }, []);

    const validate = () => {
        let isValid = true;
        const errs = {};
        if (!categoryId) {
            isValid = false;
            errs[".category"] = "Please select category";
        }
        if (!state.item) {
            isValid = false;
            errs[".item"] = "Please enter item";
        }
        if (!unit) {
            isValid = false;
            errs[".unit"] = "Please select unit";
        }
        setErrors(errs);
        return isValid;
    }
    const changeHandler = (event) => {
        setState({ ...state, [event.target.name]: event.target.value });
    };
    const categoryChangeHandler = (ev) => {
        setCategoryId(ev);
    }
    const unitChangeHandler = (ev) => {
        setUnit(ev);
    }
    const submitHandler = e => {
        e.preventDefault();
        const errs = {};
        setLoading(true);
        if (validate()) {
            fetch(
                service.ADD_UPDATE_ITEM,
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        ItemId: params.id ? params.id : null,
                        Item: state.item,
                        ItemCategoryId: categoryId.value,
                        ItemCode: state.itemcode,
                        Unit: unit.label,
                        ClientId: JSON.parse(sessionStorage.getItem('userData')).clientId,
                        AddedBy: JSON.parse(sessionStorage.getItem('userData')).userId,
                        UpdatedBy: JSON.parse(sessionStorage.getItem('userData')).userId,
                    })
                })
                .then(res => res.json())
                .then(result => {
                    if (result.messageType === 'Success') {
                        // eslint-disable-next-line
                        alert(result.message);
                        navigate('/masters/item');
                    }
                    else if (result.messageType === 'Failed') {
                        // eslint-disable-next-line
                        alert(result.message);
                        navigate('/masters/item');
                    }
                    else {
                        errs[".invalid"] = result.message.message;
                        setErrors(errs);
                    }
                });
        }
        setLoading(false);
    }

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={6} pb={3}>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Card>
                            <MDBox
                                mx={2}
                                mt={-3}
                                py={3}
                                px={2}
                                variant="gradient"
                                bgColor="info"
                                borderRadius="lg"
                                coloredShadow="info"
                            >
                                <MDTypography variant="h6" color="white">
                                    Save Details
                                </MDTypography>
                            </MDBox>
                            <Card style={{ alignItems: 'center' }}>
                                <MDBox pt={4} pb={3} px={3} style={{ width: '50%' }}>
                                    <MDBox component="form" role="form">
                                        <MDBox mb={2}>
                                            <div style={{ fontSize: '12px' }}>
                                                <Select
                                                    options={categoryData}
                                                    name="category"
                                                    value={categoryId}
                                                    onChange={categoryChangeHandler}
                                                    isSearchable
                                                    styles={selectStyles}
                                                    placeholder="Select Item Category"
                                                />
                                            </div>
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".category"]}</div>
                                        </MDBox>
                                        <MDBox mb={2}>
                                            <MDInput label="Item" fullWidth value={state.item || ''}
                                                name="item"
                                                onChange={changeHandler}
                                                id="item"
                                                required />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".item"]}</div>
                                        </MDBox>
                                        <MDBox mb={2}>
                                            <MDInput label="Item Code" fullWidth value={state.itemcode || ''}
                                                name="itemcode"
                                                onChange={changeHandler}
                                                id="itemcode"
                                                required />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".itemcode"]}</div>
                                        </MDBox>
                                        <MDBox mb={2}>
                                            <div style={{ fontSize: '12px' }}>
                                                <Select
                                                    options={unitData}
                                                    name="unit"
                                                    value={unit}
                                                    onChange={unitChangeHandler}
                                                    isSearchable
                                                    styles={selectStyles}
                                                    placeholder="Select Unit"
                                                />
                                            </div>
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".unit"]}</div>
                                        </MDBox>
                                        <MDBox mt={4} mb={1} textAlign="center">
                                            {loading ? <Oval
                                                heigth="20"
                                                width="20"
                                                color='grey'
                                                ariaLabel='loading'
                                            /> :
                                                <MDButton color="info" onClick={submitHandler}>
                                                    SAVE
                                                </MDButton>
                                            }
                                            {errors ? <div style={{ fontSize: '12px', color: 'red' }}>{errors[".invalid"]}</div> : null}
                                        </MDBox>
                                    </MDBox>
                                </MDBox>
                            </Card>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
            <Footer />
        </DashboardLayout>
    );
}

export default AddEditItem;